import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popover } from '@bufferapp/components';
import PreviewPopover from '~/story-preview';
import { actions as storiesActions } from '~/stories/reducer';
import { actions } from '../../reducer';
import StoryGroupWrapper from '../StoryGroupWrapper';
import { CloseStoryComposerConfirmationModal } from '../ClosePopOverConfirmationModal';

const StoryGroupPopover = ({
  onDeleteStoryGroup,
  onDeleteStory,
  onMonitorUpdateProgress,
  onUploadFinished,
  onDropCard,
  type,
}) => {
  const dispatch = useDispatch();
  const showStoryPreview = useSelector(
    (state) => state.storyGroupComposer.showStoryPreview
  );

  const [showDismissComposerModal, setShowDismissComposerModal] =
    useState(false);

  const handleCancelDismissModal = () => {
    setShowDismissComposerModal(false);
  };

  const handleConfirmDismissModal = () => {
    setShowDismissComposerModal(false);
    dispatch(actions.resetStoryGroupState());
    dispatch(storiesActions.handleCloseStoriesComposer());
  };

  const handlePopoverOverlayClick = () => {
    setShowDismissComposerModal(true);
  };

  return (
    <>
      {showDismissComposerModal && (
        <CloseStoryComposerConfirmationModal
          onConfirmDismissComposer={handleConfirmDismissModal}
          onCancelDismissModal={handleCancelDismissModal}
        />
      )}
      {showStoryPreview && (
        <PreviewPopover
          onCloseClick={() => {
            dispatch(actions.handleClosePreviewClick());
          }}
          view="composer"
        />
      )}
      {!showStoryPreview && (
        <Popover
          width="100%"
          top="5rem"
          onOverlayClick={handlePopoverOverlayClick}
        >
          <StoryGroupWrapper
            onDeleteStoryGroup={onDeleteStoryGroup}
            onDeleteStory={onDeleteStory}
            onUploadFinished={onUploadFinished}
            onMonitorUpdateProgress={onMonitorUpdateProgress}
            onDropCard={onDropCard}
            type={type}
          />
        </Popover>
      )}
    </>
  );
};

StoryGroupPopover.propTypes = {
  ...StoryGroupWrapper.propTypes,
};

export default StoryGroupPopover;
